import { render } from "./page-agentmeetagents.vue?vue&type=template&id=80aeecaa"
import script from "./page-agentmeetagents.js?vue&type=script&lang=js"
export * from "./page-agentmeetagents.js?vue&type=script&lang=js"

import "./page-agentmeetagents.vue?vue&type=style&index=0&id=80aeecaa&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__